import * as site from "./site";

function utilInit() {
    $(document).ready(() => {
        site.setupKendoObjects();
    });


    $(document).on("submit", "form", function (evt) {
        var form = this;

        $(form).find(":input").removeAttr("disabled");
        $(form).find("[data-role='datepicker']").each(function () {
            if ($(this).data("kendoDatePicker"))
                $(this).data("kendoDatePicker").enable(true);
        });

        $(form).find("[data-role='numerictextbox']").each(function () {
            if ($(this).data("kendoNumericTextBox"))
                $(this).data("kendoNumericTextBox").enable(true);
        });

        if ($(form).hasClass("noIntercept")) return;

        evt.preventDefault();

        form.submit();
    });

    site.enableSerializeObject();
    site.enableEnterKeypressOnDialog();
}

export function EnableStreetNumberAutoAdvance() {
    $(document).on("keypress", "#StreetNumber", evt => {
        if (evt.which < 48 || evt.which > 57) {
            evt.preventDefault();
            $("#StreetName").focus();
            if (evt.which !== 32) $("#StreetName").val($("#StreetName").val() + String.fromCharCode(evt.which));
        }
    });
}

window.EnableStreetNumberAutoAdvance = EnableStreetNumberAutoAdvance;
utilInit();